<template>
  <div class="card-modal__floating-header">
    <div class="card-modal__floating-header-wrapper" :class="visibilityClass">
      <CardHeader class="window" :card="card" />
      <ModalCloseButton />
      <transition name="scale-in-out">
        <ScrollTopButton v-if="scrollToTopHandler" :scrollable="scrollableElement" />
      </transition>
    </div>
  </div>
</template>

<script>
// Components
import ScrollTopButton from 'Ui/ScrollTopButton'
import CardHeader from 'Modules/Card/common/components/CardHeader'
import ModalCloseButton from 'Modules/Card/common/components/ModalCloseButton'

export default {
  name: 'CardModalFloatingHeader',

  components: {
    CardHeader,
    ScrollTopButton,
    ModalCloseButton,
  },

  props: {
    scrollableElement: {
      type: String,
      default: 'window',
    },

    target: {
      type: String,
      required: true,
    },

    card: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      startingPos: 0,
      currentPos: 0,
      scrollable: window,
    }
  },

  methods: {
    setup() {
      const target = this.$el.parentElement.querySelector(`[data-target=${this.target}]`)
      this.startingPos = target.scrollHeight
    },

    handleScroll() {
      this.currentPos = this.scrollable.scrollTop
    },
  },

  computed: {
    startingPosReached() {
      return this.currentPos > this.startingPos
    },

    visibilityClass() {
      return this.startingPosReached && 'visible'
    },

    scrollToTopHandler() {
      return this.currentPos > this.scrollable.scrollHeight / 2
    },

    headerTopPosition() {
      return this.currentPos - 30
    },
  },

  mounted() {
    this.setup()
    if (this.scrollableElement !== 'window')
      this.scrollable = this.$el.closest(`.${this.scrollableElement}`)

    this.scrollable.addEventListener('scroll', this.handleScroll)
  },

  beforeDestroy() {
    this.scrollable.removeEventListener('scroll', this.handleScroll)
  },
}
</script>

<style scoped>
.card-modal__floating-header {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 0;
  z-index: 10;
}

.card-modal__floating-header-wrapper {
  display: grid;
  position: relative;
  grid-template-columns: 1fr auto;
  gap: 20px;
  width: 100%;
  padding: 10px 20px;
  box-shadow: 0 2px 10px 3px var(--rgba-default);
  background-color: #fff;
  transform: translateY(-200%);
  transition: transform var(--transition--600);
}

.card-modal__floating-header-wrapper.visible {
  transform: translateY(0);
}

.card-modal__floating-header .modal-close-button {
  justify-self: flex-end;
  align-self: center;
}

@media (min-width: 769px) {
  .card-modal__floating-header >>> .card-header.window .card-header__title {
    font-size: 20px;
    line-height: 28px;
  }

  .card-modal__floating-header >>> .card-header.window .card-category {
    font-size: 8px;
    line-height: 10px;
  }
}
</style>
